<script setup>
import { XMarkIcon } from "@heroicons/vue/24/solid";
import { Text } from "@codinglabsau/ui";
import { ref } from "vue";
import axios from "axios";
import ActionButton from "../Components/Buttons/Action.vue";

const props = defineProps({
  callback: {
    required: true,
  },
  close: {
    required: true,
  },
})

const searchContent = ref('')

const results = ref([])

const search = () => {
  if(searchContent.value.length < 3){
    return results.value = []
  }

  axios.get(route('hq.contents.algolia.search'), {
    params: {
      search: searchContent.value,
    }
  }).then((response) => {
    results.value = response.data
  })
}

const select = (content) => {
  props.callback(content)
  props.close()
}
</script>

<template>
  <vue-final-modal
    classes="flex justify-center items-center modal-overflow"
    content-class="relative flex flex-col h-auto mx-auto border dark:border-gray-800 bg-white rounded-lg shadow-lg modal-overflow"
    >
    <div class="relative w-80 md:w-96 mx-auto p-6 bg-white shadow-md rounded space-y-4 z-50">
      <div class="absolute top-0 left-0">
        <ActionButton @click.prevent="close" class="border-0">
          <xMarkIcon class="w-4 h-4"/>
        </ActionButton>
      </div>
      <div class="flex flex-col mt-4 text-sm">
        <label for="searchContent" class="mb-2">{{ __('Search article') }}</label>
        <Text
          type="search"
          v-model="searchContent"
          @input="search"
          placeholder="Search article"
        />
        <span class="text-xs text-gray-400 mt-1">{{ __('Please enter at least 3 characters to search') }}</span>
      </div>
      <div v-if="results">
        <h3 class="text-base font-semibold mb-2">{{ __('Search Results') }}</h3>
        <div v-if="results.length === 0" class="text-sm text-gray-500">{{ __('No matching articles found.') }}</div>
        <div v-else>
          <div
            v-for="result in results"
            :key="result.id"
            class="flex items-center gap-4 hover:bg-gray-100">
            <button @click.prevent="select(result)" class="text-sm text-start font-medium m-1 w-full">{{ result.name }}</button>
          </div>
        </div>
      </div>
    </div>
  </vue-final-modal>
</template>
